import { useState } from "react";
import { Flag, Coins, Ban, Trophy, X } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const SLIDES = [
  {
    icon: Flag,
    color: "#FF1E27",
    title: "Benvenuto su FantasyRace!",
    text: "Trasformati in Team Principal per la 69° Salita dei Monti Iblei: componi la scuderia, scegli il Capitano e sfida gli altri tifosi sulla cronoscalata di Chiaramonte Gulfi.",
  },
  {
    icon: Coins,
    color: "#FFB703",
    title: "I tuoi Crediti",
    text: "Hai 120 crediti per scegliere i tuoi 18 piloti. Ogni pilota ha un costo: i big costano di più, le sorprese meno. Spendili con strategia!",
  },
  {
    icon: Ban,
    color: "#3B82F6",
    title: "Limiti di Classe",
    text: "Attenzione: ogni Classe di vetture consente un numero massimo di piloti (es. max 1 o 2 piloti top). Il contatore su ogni scheda ti guida nella scelta.",
  },
  {
    icon: Trophy,
    color: "#22C55E",
    title: "Salva e scala la classifica",
    text: "Conferma la squadra prima del countdown di chiusura mercato, poi segui il Live Timing, condividi la tua Social Card (+5 punti!) e sfida gli amici nelle Leghe. Buona salita!",
  },
];

export default function OnboardingModal() {
  const { user, setUser } = useAuth();
  const [step, setStep] = useState(0);
  const [saving, setSaving] = useState(false);

  if (!user || user.has_completed_onboarding !== false) return null;

  const slide = SLIDES[step];
  const last = step === SLIDES.length - 1;
  const Icon = slide.icon;

  const close = async () => {
    if (saving) return;
    setSaving(true);
    try {
      await api.post("/users/me/onboarding-complete");
    } catch {
      // il flag verra' riproposto al prossimo accesso se il salvataggio fallisce
    }
    setUser({ ...user, has_completed_onboarding: true });
  };

  return (
    <div
      data-testid="onboarding-modal"
      className="fixed inset-0 z-[100] flex items-center justify-center bg-black/80 backdrop-blur-sm p-4"
    >
      <div className="relative w-full max-w-md rounded-2xl border border-[#3F3F4C] bg-[#1A1A1E] p-8 pt-10 text-center shadow-2xl">
        <button
          data-testid="onboarding-skip"
          onClick={close}
          title="Salta tutorial"
          className="absolute top-3 right-3 flex items-center gap-1 rounded-lg px-2.5 py-1.5 font-body-sport text-[10px] font-bold tracking-widest uppercase text-gray-500 hover:text-white hover:bg-[#242429] transition-colors"
        >
          Salta <X className="w-4 h-4" />
        </button>
        <div
          className="mx-auto w-16 h-16 rounded-2xl flex items-center justify-center mb-5"
          style={{ background: `${slide.color}18`, border: `1px solid ${slide.color}55` }}
        >
          <Icon className="w-8 h-8" style={{ color: slide.color }} />
        </div>
        <h2 className="font-racing font-black text-xl uppercase tracking-wide text-white" data-testid="onboarding-title">
          {slide.title}
        </h2>
        <p className="text-sm text-gray-400 font-body-sport leading-relaxed mt-3 min-h-[72px]">{slide.text}</p>
        <div className="flex items-center justify-center gap-1.5 my-5">
          {SLIDES.map((s, i) => (
            <span
              key={s.title}
              className={`h-1.5 rounded-full transition-all ${i === step ? "w-6 bg-[#FF1E27]" : "w-1.5 bg-[#3F3F4C]"}`}
            />
          ))}
        </div>
        <button
          data-testid="onboarding-next"
          onClick={() => (last ? close() : setStep(step + 1))}
          disabled={saving}
          className="w-full rounded-lg bg-[#FF1E27] hover:bg-[#CC1118] disabled:opacity-50 transition-colors py-3 font-racing font-bold text-sm tracking-widest text-white uppercase"
        >
          {last ? "Inizia a giocare!" : "Avanti"}
        </button>
      </div>
    </div>
  );
}
